
import typeToReducer from 'type-to-reducer';

import { GET_SERVICE_COMPLETION_REFERENCE, GET_SERVICE_REFERENCE, GET_APPLICATION, CLEAR_FORM } from "../actions";

const iniState = {
  detailsRetrieving: false,
  detailsSucess: false,
  detailsError: false,
  data: undefined,
  twoFaVerified:false
}

export const twoFA = typeToReducer({
  [GET_SERVICE_COMPLETION_REFERENCE]: {
    PENDING: (state) => ({
      ...state,
      detailsRetrieving: true,
      detailsSucess: false,
      detailsError: false,
      data: undefined,
      twoFaVerified:false
    }),
    REJECTED: (state) => ({
      ...state,
      detailsRetrieving: false,
      detailsSucess: false,
      detailsError: true,
      data: undefined,
      twoFaVerified:false
    }),
    FULFILLED: (state, action) => ({
      ...state,
      detailsRetrieving: false,
      detailsSucess: true,
      detailsError: false,
      data: action.payload.data,
      twoFaVerified:true
    }),
  },
  [GET_SERVICE_REFERENCE]: {
    PENDING: (state) => ({
      ...state,
      detailsRetrieving: true,
      detailsSucess: false,
      detailsError: false,
      data: undefined,
      twoFaVerified:false
    }),
    REJECTED: (state) => ({
      ...state,
      detailsRetrieving: false,
      detailsSucess: false,
      detailsError: true,
      data: undefined,
      twoFaVerified:false
    }),
    FULFILLED: (state, action) => ({
      ...state,
      detailsRetrieving: false,
      detailsSucess: true,
      detailsError: false,
      data: action.payload.data,
      twoFaVerified:false
    }),
  },
  [GET_APPLICATION]: {
    PENDING: () => ({
      ...iniState,
      receivingApplication: true,
      receivedApplication: false,
      error: false
    }),
    REJECTED: (state) => ({
      ...state,
      receivingApplication: false,
      receivedApplication: false,
      error: true
    }),
    FULFILLED: (state, action) => ({
      ...state,
      receivingApplication: false,
      receivedApplication: true,
      error: false,
      ...action.payload.twoFA
    })
  },
  [CLEAR_FORM]: () => ({
    ...iniState
  })
}, iniState);

